import React from 'react'

import config from '../config.js'

import { MuiThemeProvider } from '@material-ui/core/styles'

import { Button } from '@material-ui/core/'

import Ingredient from './Ingredient'
import Instruction from './Instruction'
import LoadingIcon from './LoadingIcon'

class Recipe extends React.Component {
  render() {
    let recipeImg = ''
    let recipeDescription = ''
    let recipeYield = ''
    let recipeServes = ''
    let recipePrepTime = ''
    let recipeCookTime = ''
    let recipeNotes = ''
    let recipeIngredients = ''
    let recipeInstructions = ''
    let recipeActions = ''

    if (this.props.recipe === undefined) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
      )
    } else if (this.props.recipe === null) {
      return (
        <div className="warning text-center">
          The requested recipe was not found or was not shared
        </div>
      )
    } else {
      if (this.props.recipe.imageUrl) {
        recipeImg = (
          <div className="recipe__img">
            <img
              src={this.props.recipe.imageUrl}
              alt={this.props.recipe.name + ' Photo'}
              itemProp="image"
            />
          </div>
        )
      }
      if (this.props.recipe.description) {
        recipeDescription = this.props.recipe.description.replace(
          /\r?\n\r?\n|\r?\n|\r/g,
          '<br/>'
        )
        recipeDescription = (
          <div
            className="recipe__description"
            itemProp="description"
            dangerouslySetInnerHTML={{ __html: recipeDescription }}
          />
        )
      }
      if (this.props.recipe.yield) {
        recipeYield = (
          <div className="recipe__yield" itemProp="recipeYield">
            Yields: {this.props.recipe.yield}
          </div>
        )
      }
      if (this.props.recipe.serves && this.props.recipe.serves > 1) {
        recipeServes = (
          <div className="recipe__serves" itemProp="serves">
            Serves: {this.props.recipe.serves}
          </div>
        )
      }
      if (this.props.recipe.prepTime) {
        recipePrepTime = (
          <div className="recipe__prep-time" itemProp="prepTime">
            Prep Time: {this.props.recipe.prepTime}
          </div>
        )
      }
      if (this.props.recipe.cookTime) {
        recipeCookTime = (
          <div className="recipe__cook-time" itemProp="cookTime">
            Cook Time: {this.props.recipe.cookTime}
          </div>
        )
      }
      if (this.props.recipe.notes) {
        recipeNotes = this.props.recipe.notes.replace(
          /\r?\n\r?\n|\r?\n|\r/g,
          '<br/>'
        )
        recipeNotes = (
          <div
            className="recipe__notes"
          >
            <h3>Notes</h3>
            <div
              // className="recipe__notes"
              itemProp="notes"
              dangerouslySetInnerHTML={{ __html: recipeNotes }}
            />
          </div>
        )
      }
      if (
        this.props.recipe.ingredients &&
        this.props.recipe.ingredients.length >
          0 /*&& (this.props.recipe.ingredients[0].ingredient != null)*/
      ) {
        let ingredientItems = ''

        ingredientItems = this.props.recipe.ingredients.map((item, index) => (
          <Ingredient
            key={index}
            ingredient={item}
            friend={this.props.friendIdentifier}
          />
        ))

        recipeIngredients = (
          <div className="recipe__ingredients">
            <h3>Ingredients</h3>
            <ul>{ingredientItems}</ul>
          </div>
        )
      }
      if (
        this.props.recipe.instructions &&
        this.props.recipe.instructions.length > 0
      ) {
        let instructionItems = ''

        instructionItems = this.props.recipe.instructions.map((item, index) => (
          <Instruction key={index} instruction={item} />
        ))

        recipeInstructions = (
          <div className="recipe__instructions" itemProp="recipeInstructions">
            {// We have to check the ingredients--when there are no ingredients, there also will not be a "Directions" header
            this.props.recipe.ingredients &&
              this.props.recipe.ingredients.length > 0 &&
              this.props.recipe.ingredients[0].ingredient != null && (
                <h3>Directions</h3>
              )}
            {instructionItems}
          </div>
        )
      }

      // if (this.props.userLoggedIn) {
      //   recipeActions = (
      //     <div className="recipe__actions">
      //       <Button variant="contained" color="primary" title="I Love This Recipe" className="active">
      //         <span className="material-icons md-24">favorite</span>
      //         <span className="title">I Love This!</span>
      //       </Button>
      //       <Button variant="contained" color="primary" title="I Made This Recipe">
      //         <span className="material-icons md-24">restaurant</span>
      //         <span className="title">I Made This!</span>
      //       </Button>
      //       <Button variant="contained" color="primary" title="Share This Recipe">
      //         <span className="material-icons md-24">share</span>
      //         <span className="title">Share</span>
      //       </Button>
      //       <Button variant="contained" color="primary" title="Capture This Recipe">
      //         <span className="material-icons md-24">save_alt</span>
      //         <span className="title">Capture Recipe</span>
      //       </Button>
      //     </div>
      //   )
      // }

      return (
        <MuiThemeProvider theme={config.theme}>
          <div className="recipe" itemScope itemType="http://schema.org/Recipe">
            <h2 className="recipe__title" itemProp="name">
              {this.props.recipe.name}
            </h2>
            {recipeImg}
            {recipeDescription}
            {recipeYield}
            {recipeServes}
            {recipePrepTime}
            {recipeCookTime}
            {recipeNotes}
            {recipeIngredients}
            {recipeInstructions}
            {recipeActions}
          </div>
        </MuiThemeProvider>
      )
    }
  }
}

export default Recipe



// WEBPACK FOOTER //
// ./src/Components/Recipe.js